<template>
    <div class="white pa-4">
        <Block v-if="loading" />

        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <v-autocomplete v-model="customer" :items="ClientList" label="Cliente" item-text="name"
                    item-value="value" outlined dense attach @change="getData()" />
            </v-col>
            <v-col cols="12" md="6">
                <v-autocomplete v-model="id_seller" outlined dense attach label="Vendedor" :items="ExpiredAccountsSellerList" item-text="name"
                    item-value="value" @change="getData()"></v-autocomplete>
            </v-col>
            <!-- Ocultado temporalmente
            <v-col cols="12" md="6" class="d-flex justify-end">
                <v-btn class="btn-save" @click="setupPrint">
                    <v-icon>mdi-printer</v-icon>
                </v-btn>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="search.envType">
                    <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                    <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
        <VersatileFilter :columnsSearch="columsConfig" :search="search" @emptyFilter="getData"
            advancedFilter @filtered="filterHandler" :key="Reloadfilter"
            @setDatesToSend="value => dates = value" @enabledate="(e) => {useDate = e;}"
            :columnfilterEndpoint="getData">
            <DxDataGrid :dataSource="DataTable" :columns="columnsList" @exporting="onExporting"
                :word-wrap-enabled="true" :scrolling="{ useNative: true }" :column-auto-width="true">
                <DxExport :enabled="true" />
                <template #show-template-class="{ data }">
                    <div>{{ showClass(data.data.id_class) }}</div>
                </template>
                <template #show-template-category="{ data }">
                    <div>{{ showCategories(data.data.id_category) }}</div>
                </template>
                <template #show-template-subcategory="{ data }">
                    <div>{{ showSubs(data.data.id_subcategory) }}</div>
                </template>
                <DxSummary>
                    <DxTotalItem
                        column="InvoiceDate"
                        display-format="Totales"
                    />
                    <DxTotalItem
                        column="PaymentWithIvaWithoutNc"
                        summary-type="sum"
                        :value-format="formatCurrencyValue"
                        display-format="{0}"
                    />
                    <DxTotalItem
                        column="abonado"
                        summary-type="sum"
                        :value-format="formatCurrencyValue"
                        display-format="{0}"
                    />
                    <DxTotalItem
                        column="PendingToPay"
                        summary-type="sum"
                        :value-format="formatCurrencyValue"
                        display-format="{0}"
                    />
                </DxSummary>

                <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                <DxPaging :page-size="10" />
            </DxDataGrid>
        </VersatileFilter>

        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert" />
        <div>
            <component v-for="(item, index) in PrintList" :key="index" :is="item.component" v-bind="item.props" />
        </div>
    </div>
</template>

<script>

//import {mapState} from 'vuex';
import VersatileFilter from '@/components/VersatileFilter.vue';
import { DxDataGrid, DxPager, DxPaging, DxExport, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid';
import Block from '@/components/Block.vue';
import Alerts from '@/components/Alerts.vue';
import { printToExcel } from "@/helpers/printToexcel";
import PrintAccountsReceivableStatement from "@/components/ReportsAndPrintings/SalesReports/PrintAccountsReceivableStatement"
import { numberWithCommas } from '@/helpers/money';
export default {
    name: "CustomersAccountsReceivable",
    components: {
        DxDataGrid,
        DxPager,
        DxPaging,
        Block,
        Alerts,
        DxExport,
        DxSummary,
        DxTotalItem,
        VersatileFilter,
        PrintAccountsReceivableStatement
    },
    props: ['win'],
    data() {
        const additionalInformationTitle = Number(JSON.parse(localStorage.getItem("user") || "{}").IsOptical) === 1
            ? "Lugar de trabajo"
            : "Información adicional";
        return {
            additionalInformationTitle,
            PrintList: [],
            print: {
                show: false,
                header: {
                },
                data: [],
            },
            Customers: [],
            DataTable: [],
            panel: 0,
            tab: null,
            key: 0,
            loading: false,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            ClientList: [],
            ExpiredAccountsSellerList: [],
            requestDate: null,
            customer: null,
            currencyColumnsToExport: [
                "PaymentWithIvaWithoutNc",
                "abonado",
                "PendingToPay",
            ],
            columnsList: [
                { dataField: "CodigoGeneracion", caption: "Código generación" },
                { dataField: "ID_Invoice", caption: "No. Documento" },
                { dataField: "LegalName" , caption: "Nombre Legal" },
                { dataField: "AdditionalInformation", caption: additionalInformationTitle },
                { cellTemplate:"show-template-class" , caption: "Clase" },
                { cellTemplate:"show-template-category" , caption: "Categoría" },
                { cellTemplate:"show-template-subcategory" , caption: "Subcategoría" },
                // { dataField: "FullNameCustomer" , caption: "Nombre Legal" },
                { dataField: "InvoiceDate", caption: "Fecha de la Factura" },
                { dataField: "PaymentDate", caption: "Fecha de Pago" },
                { dataField: "PaymentWithIvaWithoutNc", caption: "Monto total", alignment: "right", customizeText: ({ value }) => this.formatCurrencyValue(value) },
                { dataField: "abonado", caption: "Monto de abono", alignment: "right", customizeText: ({ value }) => this.formatCurrencyValue(value) },
                { dataField: "PendingToPay", caption: "Nuevo saldo", alignment: "right", customizeText: ({ value }) => this.formatCurrencyValue(value) },
                // { dataField: "Minor15Formatted", caption: "Menor a 15 Días" },
                // { dataField: "Major15Formatted", caption: "Mayor a 15 Días" },
                // { dataField: "ExpiredBalanceFormatted", caption: "Saldo Vencido" },
            ],
            columsConfig: [
                //{ name: "ID_Customer", title: "ID Cliente", value: "", type: "text" },
                //{ name: "LegalName", title: "Nombre de Cliente", value: "", type: "text" },
                { name: "ID_Invoice", title: "ID Factura", value: "", type: "text" },
                {
                    name: "id_class",
                    title: "Clase",
                    value: "",
                    type: "select",
                    options: [],
                    onChange: this.getCategoriesByClass,
                },
                {
                    name: "id_category",
                    title: "Categoría",
                    value: "",
                    type: "select",
                    options: [],
                    onChange: this.getSubsByCategory,
                    disabled: true,
                },
                {
                    name: "id_subcategory",
                    title: "Subategoría",
                    value: "",
                    type: "select",
                    options: [],
                    disabled: true,
                },
                { name: "AdditionalInformation", title: additionalInformationTitle, value: "", type: "text" },
            ],
            Currency: JSON.parse(localStorage.getItem('branch')).Currency || "",
            idbusiness: JSON.parse(localStorage.getItem("user")).businessid || "",
            idbranch: JSON.parse(localStorage.getItem("user")).branch || "",
            search: {
                ID_Customer: null,
                envType: '01',
            },
            dates: {},
            useDate : false,
            Reloadfilter: 0,
            businessAndBranchInfo: [],
            clasesAll: [],
            categoriesAll: [],
            subcategoriesAll: [],
        }
    },
    watch: {
        envType() {
            this.getData();
        }
    },  
    computed: {

    },
    async mounted() {
        const date = new Date()
        this.requestDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()}`;
        await this.loadSellers();
        await this.getCustomersAccountStatus()
        if (this.Customers.length > 0) {
            await this.loadData();
        }
        this.getClasses();
        this.getCategories();
        this.getSubs();
    },
    methods: {
        async loadData() {
            await this.getData();
        },
        async loadSellers(){
            try {
                const { data: response } = await this.$API.customers.getExpiredAccountsReceivableSellers( this.requestDate, this.daysOfDue );
                this.ExpiredAccountsSellerList.push({name: "Sin Vendedor Asignado", value: 'ALL'});
                this.ExpiredAccountsSellerList.push(...response);
                this.id_seller = this.ExpiredAccountsSellerList[0].value;
            } catch (error) {
                this.showAlert( 'error', 'Error', 'No fue posible cargar los datos del vendedor' );
            }
        },
        async getCustomersAccountStatus() {
            try {
                this.loading = true;
                const customers = await this.$API.customers.getCustomerAccountStatus()
                this.Customers = customers.map((customer) => ({
                    name: customer.LegalName,
                    value: customer.ID_Customer,
                    address: customer.Address
                }));

                if (this.Customers.length > 0) {
                    this.ClientList.push({ name: "Sin Cliente Asignado", value: '' });
                    this.ClientList.push({ name: "Ver Todos Los Clientes Asignados", value: 'ALL' });
                    this.ClientList.push(...this.Customers);
                    this.customer = this.ClientList[0].value;
                    this.search.ID_Customer = this.customer;
                }
            } catch (error) {
                console.error(error)
                this.showAlert('danger', 'Error', error.response.data.message);
            } finally {
                this.loading = false;
            }
        },
        onExporting(e) {
            if(this.customer == '') {
                return;
            }
            const customerdata = this.customer == 'ALL' ? this.ClientList : this.Customers.find(customer => customer.value === this.customer);
            printToExcel(
                e,
                `Reporte de cobros${this.customer == 'ALL' ? `` : ` ${customerdata.name}`}`,
                null,
                "",
                true,
                true,
                null,
                { customizeCell: this.customizeCurrencyExcelCell }
            );
        },
        filterHandler(data) {
            if (data.length > 0) {
                this.DataTable = data.map(item => {
                    return item
                });
                return;
            }
            this.DataTable = [];

        },
        setupPrint() {
            if(this.customer === this.ClientList[0].value) {
                return;
            }
            this.print.data.body = this.DataTable;
            this.print.header.title = "Reporte de Cuentas por Cobrar por Vendedor ";
            const customer = this.ClientList.find(customer => customer.value === this.customer);
            
            if (customer.value == 'ALL') {
                this.print.header.subtitle = "Sin vendedor asignado";
            }
            else {
                this.print.header.subtitle = "ID : " + customer.value + " - " + customer.name;
            }
            this.print.show = true;
            this.PrintList.push({
                component: PrintAccountsReceivableStatement, props: {
                    dataProps: this.print,
                    dataCustomer: customer,
                    bussinessInfo: this.businessAndBranchInfo
                }
            });
        },
        async getData(find) {
            // console.log(`getData`, this.customer);
            try {
                this.loading = true;
                this.search.ID_Customer = this.customer;

                if(this.customer === this.ClientList[0].value) {
                    this.DataTable = [];
                    // this.Reloadfilter++;
                    return;
                }

                this.search.ID_Seller = this.id_seller;
                // this.Reloadfilter++;
            
                // console.log('this.customer', this.customer)
                // console.log('this.envType', this.envType)
                // console.log('this.dates', this.dates);
                // console.log('this.useDate', this.useDate)
                

                let response = await this.$API.customers.getCustomerAccountStatement({
                    extraParam1: this.extraParam1, 
                    filter : find?.filter ?? JSON.stringify([]),
                    business: this.search.business,
                    branch: this.search.branch,
                    search: JSON.stringify(this.search),
                    like: find?.like,
                    selectedItem: this.radioSelect != [] ? this.selectedItem : null,
                    dates: this.useDate ? JSON.stringify( {
                        ...this.dates
                    }) : JSON.stringify({}),
                    hideNoStockRecords: this.oNoStockRecords,
                    envType: this.search.envType,
                });
                if (response.length > 0) {
                    this.DataTable = response
                    this.formatTable()
                }
                else {
                    this.DataTable = [];
                }

                const response2 = await this.$API.branches.findSpecificBranch(
                    { "branch": this.idbranch, "business": this.idbusiness })
                this.businessAndBranchInfo = response2
            } catch (error) {
                console.error(error)
                this.showAlert('danger', 'Error', error.response.data.message);
            } finally {
                this.loading = false;
            }
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;
        },
        normalizeCurrencyValue(value) {
            if (typeof value === 'string') {
                const normalizedString = value
                    .replace(this.Currency, '')
                    .replace(/,/g, '')
                    .trim();
                const parsedStringValue = Number(normalizedString);
                return Number.isFinite(parsedStringValue) ? parsedStringValue : 0;
            }

            const parsedValue = Number(value);
            return Number.isFinite(parsedValue) ? parsedValue : 0;
        },
        handleNumber(value) {
            return value ? numberWithCommas(value) : 0.00;
        },
        formatCurrencyValue(value) {
            return `${this.Currency} ${numberWithCommas(this.normalizeCurrencyValue(value))}`;
        },
        customizeCurrencyExcelCell({ gridCell, excelCell }) {
            if (!gridCell || !gridCell.column || !this.currencyColumnsToExport.includes(gridCell.column.dataField)) {
                return;
            }

            if (gridCell.rowType !== 'data' && gridCell.rowType !== 'totalFooter') {
                return;
            }

            excelCell.value = this.normalizeCurrencyValue(gridCell.value);
            excelCell.numFmt = `"${this.Currency}"#,##0.00`;
            excelCell.alignment = { horizontal: 'right' };
        },
        formatTable() {
            this.DataTable.map((invoice) => {
                console.log(invoice.IsInvoiceExpired, invoice.TotalDebt)
                if (invoice.IsInvoiceExpired == 'Mayor 15 días') {
                    invoice.InvoiceCreditOldCalc = invoice.TotalDebt
                    invoice.InvoiceCreditOld = `${this.Currency} ${this.handleNumber(invoice.TotalDebt)}`
                } else if (invoice.IsInvoiceExpired == 'Menor 15 días') {
                    invoice.InvoiceCreditNewCalc = invoice.TotalDebt
                    invoice.InvoiceCreditNew = `${this.Currency} ${this.handleNumber(invoice.TotalDebt)}`
                } else if (invoice.IsInvoiceExpired == 'Vencida') {
                    invoice.PendingToPayDueCalc = invoice.TotalDebt
                    invoice.PendingToPayDue = `${this.Currency} ${this.handleNumber(invoice.TotalDebt)}`
                }
            })
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        getClasses() {
            this.$API.customersTypes.getClasses().then((response) => {
                this.columsConfig[1].options = response.map(element => ({name: element.name, value: element.id}));
                this.clasesAll = response;
            });
        },
        getCategories() {
            this.$API.customersTypes.getCategories().then((response) => {
                this.columsConfig[2].options = response.map(element => ({name: element.name, value: element.id}));
                this.categoriesAll = response;
            });
        },
        getSubs() {
            this.$API.customersTypes.getSubs().then((response) => {
                this.columsConfig[3].options = response.map(element => ({name: element.name, value: element.id}));
                this.subcategoriesAll = response;
            });
        },
        getCategoriesByClass() {
            delete this.columsConfig[2].value;
            delete this.columsConfig[3].value;
            this.columsConfig[2].options = this.categoriesAll.filter(element => element.id_class === this.columsConfig[3].value).map(element => ({name: element.name, value: element.id}));
            this.columsConfig[2].disabled = false;
            this.columsConfig[3].disabled = true;
        },
        getSubsByCategory() {
            delete this.columsConfig[3].value;
            this.columsConfig[3].options = this.subcategoriesAll.filter(element => element.id_cat === this.columsConfig[4].value).map(element => ({name: element.name, value: element.id}));
            this.columsConfig[3].disabled = false;
        },
        showClass(idClass) {
            const classData = this.clasesAll.find(element => element.value === idClass);
            return classData?.name ?? '';
        },
        showCategories(idCategory) {
            const categoryData = this.categoriesAll.find(element => element.id === idCategory);
            return categoryData?.name ?? '';
        },
        showSubs(idSubcategory) {
            const subcategoryData = this.subcategoriesAll.find(element => element.id === idSubcategory);
            return subcategoryData?.name ?? '';
        },
    },

}
</script>

<style scoped>
.bar {
    width: 100%;
    background-color: rgb(60, 60, 60) !important;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-radius: 15px !important;
    margin-top: 1rem !important;
}

.btn-add {
    background-color: #3498DB !important;
    color: white;
}

.btnsave {
    background-color: #00A178 !important;
    color: white;
}

.btnclean {
    background-color: #F29D35 !important;
    color: white;
}

.btndelete {
    background-color: #E3191E !important;
    color: white;
}
</style>
